var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.273193 19.9999C0.273193 8.95418 9.16622 0 20.1366 0C31.107 0 40 8.95418 40 19.9999C40 31.0458 31.107 40 20.1366 40C9.16622 40 0.273193 31.0458 0.273193 19.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.3933L10.6432 13.8017H11.3527L12.4256 21.4786C13.6983 19.9844 15.1856 18.5263 16.8614 17.1655C23.4988 11.7763 33.1429 10.0977 38.051 10.1268C33.114 11.2095 28.0047 13.0014 24.0768 15.7592C19.8119 18.7535 16.852 22.502 15.9176 25.6709L15.8511 25.8866L15.6766 26.3842L9.73182 26.3899L9.09432 26.3933L8.1006 18.478L1.2903 26.501L0 26.3933Z",
    fill: "url(#paint0_linear_12_3000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0056 26.4046V20.4985H25.263V21.156H23.3078V23.1247H24.6138V23.7784H23.3078V25.7471H25.263V26.4046H22.0056Z",
    fill: "url(#paint1_linear_12_3000)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1079 21.8119H30.4455C30.3883 21.3647 30.1793 21.141 29.8182 21.141C29.5845 21.141 29.4079 21.1974 29.2884 21.3098C29.1715 21.4223 29.113 21.5911 29.113 21.8159C29.113 21.9834 29.178 22.1402 29.3078 22.2867L30.7183 23.8794C30.978 24.1724 31.1078 24.4875 31.1079 24.8249V25.1622C31.1079 25.526 30.978 25.8398 30.7183 26.1038C30.4585 26.368 30.1455 26.5001 29.7793 26.5001H29.113C28.6714 26.5001 28.3389 26.389 28.1156 26.1665C27.8947 25.9418 27.7844 25.607 27.7844 25.1622H28.4506C28.448 25.2093 28.4468 25.246 28.4468 25.2721C28.4468 25.4553 28.5156 25.5938 28.6533 25.6879C28.7936 25.7822 28.9467 25.8292 29.113 25.8292C29.3494 25.8292 29.5194 25.7717 29.6234 25.6566C29.7273 25.5416 29.7792 25.3742 29.7793 25.1544C29.7793 24.9845 29.7142 24.8276 29.5845 24.6836L28.174 23.0948C27.9143 22.8045 27.7844 22.4894 27.7844 22.1493V21.8119C27.7844 21.4484 27.9143 21.1346 28.174 20.8704C28.4337 20.6064 28.7467 20.4743 29.113 20.4741H29.7793C30.6104 20.4741 31.0533 20.9202 31.1079 21.8119Z",
    fill: "url(#paint2_linear_12_3000)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9874 21.8119H36.325C36.2678 21.3647 36.0588 21.141 35.6978 21.141C35.464 21.141 35.2873 21.1974 35.1679 21.3098C35.051 21.4223 34.9925 21.5911 34.9925 21.8159C34.9925 21.9834 35.0575 22.1402 35.1873 22.2867L36.5978 23.8794C36.8575 24.1724 36.9873 24.4875 36.9874 24.8249V25.1622C36.9874 25.526 36.8575 25.8398 36.5978 26.1038C36.3379 26.368 36.0251 26.5001 35.6587 26.5001H34.9925C34.5509 26.5001 34.2184 26.389 33.9952 26.1665C33.7742 25.9418 33.6639 25.607 33.6639 25.1622H34.3301C34.3275 25.2093 34.3263 25.246 34.3263 25.2721C34.3263 25.4553 34.3951 25.5938 34.5328 25.6879C34.6731 25.7822 34.8262 25.8292 34.9925 25.8292C35.2289 25.8292 35.3989 25.7717 35.5029 25.6566C35.6068 25.5416 35.6587 25.3742 35.6587 25.1544C35.6587 24.9845 35.5938 24.8276 35.464 24.6836L34.0536 23.0948C33.7938 22.8045 33.6639 22.4894 33.6639 22.1493V21.8119C33.6639 21.4484 33.7938 21.1346 34.0536 20.8704C34.3132 20.6064 34.6262 20.4743 34.9925 20.4741H35.6587C36.4899 20.4741 36.9328 20.9202 36.9874 21.8119Z",
    fill: "url(#paint3_linear_12_3000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_3000",
    x1: 19.0255,
    y1: 10.1265,
    x2: 19.0255,
    y2: 26.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12699F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12699F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_3000",
    x1: 23.6343,
    y1: 20.4985,
    x2: 23.6343,
    y2: 26.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12699F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12699F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_3000",
    x1: 29.4462,
    y1: 20.4741,
    x2: 29.4462,
    y2: 26.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12699F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12699F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_3000",
    x1: 35.3257,
    y1: 20.4741,
    x2: 35.3257,
    y2: 26.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12699F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12699F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.352b8e00bb929fa99e0a42071e180e17.svg";
export { ForwardRef as ReactComponent };